<template>
  <div id="app" v-loading="loading">
    <div v-if="isAuth">
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        :router="true"
        :default-active="activeMenu"
      >
        <el-menu-item :router="true" index="/">
          <div
            :style="{ 'background-color': userColor }"
            style="
              width: 40px;
              height: 40px;
              border-radius: 50px;
              line-height: 40px;
              display: inline-block;
              text-align: center;
              font-weight: bold;
              font-size: 20px;
              margin-right: 10px;
            "
          >
            {{ userLetter }}
          </div>
          <span>{{ userName }}</span>
        </el-menu-item>
        <el-menu-item @click="requestFormVisible = true"
          >Delivery request</el-menu-item
        >
        <!--        <el-menu-item :router="true" index="/piggybank">Копилка</el-menu-item>-->

        <el-menu-item style="float: right" @click="exit">
          <span>Log out</span>
        </el-menu-item>
      </el-menu>
      <router-view />
      <el-dialog title="Delivery request" :visible.sync="requestFormVisible">
        <el-form :model="requestForm">
          <el-form-item label="Request description">
            <el-input type="textarea" v-model="requestForm.desc"></el-input>
          </el-form-item>
          <el-form-item label="Pick up at">
            <el-date-picker
              v-model="requestForm.takeDate"
              type="datetime"
              placeholder="Select date and time"
              class="datetimepicker"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Deliver at time">
            <el-date-picker
              v-model="requestForm.deliverDate"
              type="datetime"
              placeholder="Select date and time"
              class="datetimepicker"
            >
            </el-date-picker>
          </el-form-item>
          <el-checkbox v-model="requestForm.urgent">Urgent</el-checkbox>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="requestFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="addRequest">Add</el-button>
        </span>
      </el-dialog>
    </div>
    <div v-else>
      <el-form
        :model="form"
        status-icon
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
        style="margin-top: 50px"
      >
        <el-form-item label="User" prop="pass">
          <el-row class="row-bg" justify="center">
            <el-col :span="8" v-for="member of members" :key="member.id">
              <el-radio
                v-model="form.userID"
                :label="member.id"
                border
                style="margin: 10px; margin-top: 0; margin-bottom: 20px"
                >{{ member.value }}
              </el-radio>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item label="PIN-code" prop="pass">
          <el-input
            type="password"
            v-model="form.pass"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm">Sign in</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import order from "../api/order";

var Airtable = require("airtable");
var base = new Airtable({
  apiKey:
    "patX2CzsS0Z6zdSmp.8a1700e7223e27ef4787f07602fa89ab3451324f51162ea66bc0a9dbc32b170b",
}).base("appBSigNkslhpQDbK");

export default {
  data() {
    return {
      requestFormVisible: false,
      activeMenu: this.$route.path,
      userName: "",
      userColor: "",
      isAuth: false,
      loading: true,
      members: [],
      requestForm: {
        desc: "",
        takeDate: null,
        deliverDate: null,
        urgent: false,
      },
      form: {
        userID: "",
        pin: "",
      },
    };
  },
  computed: {
    userLetter: function () {
      if (this.userName) {
        return this.userName.substring(0, 1);
      }
      return "";
    },
  },
  methods: {
    addRequest() {
      if (this.requestForm.desc.length === 0) {
        this.$notify.error({
          title: "Error",
          message: "Request's description is empty",
          duration: 4500,
        });
        return;
      }
      let obj = new Object();
      let fieldsObj = new Object();
      let tgNotification =
        "🔔 Created " +
        (this.requestForm.urgent ? "URGENT " : "") +
        "delivery request: ";
      obj.Description = this.requestForm.desc;
      tgNotification += this.requestForm.desc + ". ";
      obj.CreatedBy = this.userName;
      tgNotification += "By: " + this.userName + ". ";
      if (this.requestForm.takeDate) {
        obj.Takeaway = this.requestForm.takeDate.toISOString();
      }
      if (this.requestForm.deliverDate) {
        obj.Deliver = this.requestForm.deliverDate.toISOString();
      }
      obj.Urgent = this.requestForm.urgent;
      fieldsObj.fields = obj;
      base("List").create([fieldsObj], function (err, records) {
        if (err) {
          console.error(err);
          this.$notify.error({
            title: "Error",
            message: "Something went wrong..",
          });
          return;
        }
        records.forEach(function (record) {
          console.log(record.getId());
        });
      });
      this.requestFormVisible = false;
      this.$notify({
        type: "success",
        message: "Request was successfully sent",
        title: "Hooray!",
        position: "bottom-right",
      });
      order.TgCourierNotify(tgNotification);
      this.requestForm = {
        desc: "",
        takeDate: null,
        deliverDate: null,
        urgent: false,
      };
    },
    exit() {
      localStorage.userName = "";
      localStorage.userColor = "";
      localStorage.token = "";
      this.isAuth = false;
    },
    submitForm() {
      this.loading = true;
      order.isValid(this.form.userID, this.form.pass).then((response) => {
        let data = response.data.data;
        if (data.find) {
          this.isAuth = true;
          let member = this.members.find((item) => {
            if (item.id == this.form.userID) {
              return item;
            }
          });
          localStorage.token = this.form.userID;
          localStorage.userName = member.value;
          localStorage.userColor = member.color;
          this.userName = member.value;
          this.userColor = member.color;
          this.form.pass = "";
        } else {
          this.$message.error("Invalid password");
        }
        this.loading = false;
      });
    },
  },
  mounted() {
    order.getMembers().then((response) => {
      let members = response.data.data;
      this.members = members;
    });
    this.userName = localStorage.userName;
    this.userColor = localStorage.userColor;
    if (localStorage.token) {
      this.isAuth = true;
    }
    this.loading = false;
  },
};
</script>
<style>
body {
  margin: 0;
  font-family: "Open Sans", sans-serif;
}
.el-dialog {
  width: 90% !important;
}
.datetimepicker {
  width: 100% !important;
}
</style>
